module.exports = __webpack_public_path__ + "static/media/font-icon.bdce9915.svg";